import React, { useState } from "react"
import styled from "styled-components"
import {AiOutlineEye, AiOutlineEyeInvisible} from 'react-icons/ai'
import {darkTheme} from '../components/Themes'
const FormInput = ({
  id,
  value,
  label,
  handleOnChange,
  placeholder,
  isReq,
  type,
  accept,
  inpName,
  isPassword
}) => {
  const [showPass, setShowPass] = useState('password')

  return (
    <InputWrap>
      <label htmlFor={id}>{label}</label>
       <input
        name={inpName}
        type={isPassword? showPass : type}
        id={id}
        rows="4"
        cols="50"
        required={isReq}
        accept={accept}
        className="input_field"
        value={value}
        placeholder={placeholder}
        onChange={handleOnChange}
      />
      {
        isPassword &&
        (
          showPass === 'password'?
          <AiOutlineEyeInvisible className="eyeicon" onClick={() => setShowPass("text")} size={20} color={darkTheme.accent}  />
          :
          <AiOutlineEye className="eyeicon"  onClick={() => setShowPass("password")} size={20} color={darkTheme.accent}  />
        )
      }
    </InputWrap>
  )
}

export default FormInput

const InputWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 0rem;
  position: relative;

  label {
    color: grey;
    font-size: 0.8rem;
    margin-bottom: 0.5rem;
    user-select: none;
  }

  .input_field {
    background: ${({ theme }) => theme.background};
    border: 1px solid rgba(0, 0, 0, 0.6);
    box-sizing: border-box;
    border-radius: 6px;
    height: 2.5rem;
    padding: 1rem 0.5rem;
    color: ${({ theme }) => theme.text};
    transition: 0.2s ease all;
    :focus {
      outline: ${({ theme }) => theme.accent} solid 2px;
      box-shadow: 0px 0px 15px -5px rgba(224, 20, 13, 1);
    }
  }

  .eyeicon {
    position: absolute;
    right: .5rem;
    top: 2.1rem;
    bottom: 0rem;
  }
`
